<script>
  import projetoServico from '~modulos/projeto/servico';
  import 'vue-strap/dist/vue-strap-lang';

  export default {
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        projetos: [],
        projetoRateio: this.camposProjetos(),
      }
    },
    methods: {
      camposProjetos() {
        return {
          idProjeto: '',
          percentual: '',
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
          },
        }
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) {
              throw new Error("validacao");
            }
            else {
              this.solicitacao.projetos.push(this.projetoRateio);
              this.projetoRateio = this.camposProjetos();
              $('#projeto').val('0');
              this.iniciarSelect2Projeto();
              this.$validator.reset();
            }
          })
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      validarProjeto() {
        return ((this.solicitacao.projetos.length > 0) && (this.total == 100));
      },
      deletarProjeto(indice) {
        this.solicitacao.projetos.splice(indice, 1);
        this.solicitacao.projetos.splice(indice, 1);
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolCursoEventoServico")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.projetoRateio, 'projeto', projeto);
          }
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
        .change(function(e) {
          _this.$set(_this.projetoRateio, 'idProjeto', this.value);

          _this.setarProjeto(this.value);

          if (!this.value) return;
        });
      },
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
    },
    computed: {
      total: function () {
        return this.solicitacao.projetos.reduce((somatorio, item) => {
          const valorEstimado = this.$options.filters.formatarNumero(item.percentual, true);
          return somatorio + valorEstimado
        }, 0);
      },
    },
    mounted() {
      this.listaDeProjetos();
      this.iniciarSelect2Projeto();
    },
  }
</script>

<template>
<div>
  <div class="ibox-footer">
    <div class="table-responsive">
      <table class="table table-bordered table-column-code table-column-action">
        <thead v-if="solicitacao.projetos.length > 0">
          <tr>
            <th></th>
            <th>Projeto</th>
            <th>Percentual (%)</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="solicitacao.projetos.length > 0">
          <tr v-for="(rateio, index) in solicitacao.projetos">
            <td></td>
            <td>{{ rateio.projeto.nomeProjeto }}</td>
            <td>{{ rateio.percentual  }}</td>
            <td>
              <div class="form-group no-margins">
                <button type="button"
                        class="btn btn-sm btn-danger btn-delete-item"
                        title="Excluir item"
                        @click="deletarProjeto(index)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot v-if="solicitacao.projetos.length === 0">
          <tr>
            <td class="text-center">Nenhum rateio de projeto encontrado.</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

    <div class="bs-callout bs-callout-primary">
      <h4>Percentual total: {{ total | formatarNumero }} %</h4>
    </div>

    <div class="row">
      <div class="col-xs-10">
        <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
          <label class="control-label" for="projeto">Projeto</label>

          <select id="projeto"
           class="form-control"
           v-model="projetoRateio.idProjeto"
           data-vv-name="projeto"
           v-validate="'required'">
             <option value="0">Selecione o projeto...</option>
             <option :value="projeto.idProjeto"
                     v-for="(projeto, index) in projetos"
                     :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolCursoEventoServico) || projeto.acompanhamentoPendente">
               {{ projeto.nomeProjeto }}

               <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolCursoEventoServico)">
                 (Data limite até: {{ projeto.dataLimiteSolCursoEventoServico | formatarData }})
               </template>
             </option>
           </select>

          <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
        </div>
      </div>

      <div class="form-group required col-xs-2" :class="{'has-error': errors.has('percentual')}">
        <label class="control-label" for="percentual">Percentual (%)</label>

        <input type="text"
               class="form-control text-right"
               id="percentual"
               v-mascara="'porcentagem'"
               v-model="projetoRateio.percentual"
               data-vv-name="percentual"
               data-vv-as="percentual"
               v-validate="'required|not_zero'">

        <p class="text-danger" v-show="errors.has('percentual')">{{ errors.first('percentual') }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-success" @click="validar">
            <i class="fa fa-plus"></i>
            Adicionar projeto
          </button>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-curso-evento-servico/componentes/compartilhado/FormDadosProjetos.vue